import * as React from 'react';
import { Image } from 'mangools-react-components/src';
import Emoji from 'components/other/Emoji';

type InvalidInputMessageProps = {
    colorScheme: string;
    juiceImage: string;
    mangoolsLogoImage: string;
    mangoolsLogoWhiteImage: string;
    onClose: () => void;
};

const InvalidInputMessageContent = (props: InvalidInputMessageProps): React.ReactElement => {
    const renderHeader = () => {
        return (
            <h3 className="font-24 uk-text-bold">
                Invalid Input
                <span className="mg-margin-l-5">
                    <Emoji symbol="⚠️" label="warning" />
                </span>
            </h3>
        );
    };

    const renderContent = () => {
        return (
            <div>
                <p className="mg-margin-b-30">
                    The data you provided is invalid. Please check your input and try again.
                </p>
                <p>
                    <button
                        type="button"
                        className="mg-btn is-green"
                        onClick={props.onClose}
                    >
                        <strong>OK</strong>
                    </button>
                </p>
            </div>
        );
    };

    return (
        <>
            <div className="mg-modal-header is-mngls bg-fff">
                <img src={props.juiceImage} alt="Invalid Input" width="110" />
            </div>
            <div className="mg-modal-content bg-fff">
                {renderHeader()}
                {renderContent()}
                <Image
                    className="mg-margin-b-5 mg-margin-t-15"
                    lightSrc={props.mangoolsLogoImage}
                    darkSrc={props.mangoolsLogoWhiteImage}
                    colorScheme={props.colorScheme}
                    alt="Mangools logo"
                    width="140"
                />
                <div className="font-14">Juicy SEO tools you will love</div>
            </div>
        </>
    );
};

export default InvalidInputMessageContent;
